import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GeometricFormModule } from '../geometrics-form/geometric-form.module';
import { SharedModule } from '../shared/shared.module';
import { LayerLegendComponent } from './layer-legend/layer-legend.component';
import { LayerListComponent } from './layer-list/layer-list.component';
import { LayerMenuComponent } from './layer-menu/layer-menu.component';
import { LayerVisualizationControlComponent } from './layer-visualization-control/layer-visualization-control.component';
import { LayerNamePipe } from './pipes/layer-name.pipe';
import { BuildingBorderPlotter } from './plotters/building-border-plotter';
import { BuildingPlotter } from './plotters/building-plotter';
import { EdgePlotter } from './plotters/edge-plotter';
import { PLOTTER } from './plotters/plotter';
import { VertexPlotter } from './plotters/vertex-plotter';
import { ResultLegendComponent } from './result-legend/result-legend.component';

@NgModule({
  declarations: [
    LayerListComponent,
    LayerNamePipe,
    LayerMenuComponent,
    LayerVisualizationControlComponent,
    LayerLegendComponent,
    ResultLegendComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    GeometricFormModule
  ],
  exports: [
    LayerListComponent,
    LayerLegendComponent,
    ResultLegendComponent
  ],
  providers: [
    { provide: PLOTTER, useClass: BuildingPlotter, multi: true },
    { provide: PLOTTER, useClass: EdgePlotter, multi: true },
    { provide: PLOTTER, useClass: VertexPlotter, multi: true },
    { provide: PLOTTER, useClass: BuildingBorderPlotter, multi: true }
  ]
})
export class LayersModule { }
